import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Pane, SearchInput, majorScale } from '@segment/react-ui-library'
import { humanizeKey, parseValue } from 'lib/transform-record'
import { omitBy, isNil, isEmpty } from 'lodash'
import Card from './presentational/Card'
import Row from './presentational/Row'

class CustomersProfileTraits extends Component {
  render () {
    return (
      <Card>
        <Pane white padding={majorScale(2)} borderBottom>
          <SearchInput placeholder='Filter User Info...' onChange={(e) => this.props.onSearch(e.target.value)} />
        </Pane>
        <Pane>
          {Object.keys(omitBy(omitBy(this.props.traits, isNil), isEmpty)).map(trait => (
            <Row key={trait} label={humanizeKey(trait)}>
              {parseValue(this.props.traits[trait]) || ' '}
            </Row>
          ))}
        </Pane>
      </Card>
    )
  }

  // clear filter when component is unmounted
  componentWillUnmount () {
    this.props.onSearch('')
  }
}

CustomersProfileTraits.displayName = 'CustomersProfileTraits'

CustomersProfileTraits.propTypes = {
  onSearch: PropTypes.func.isRequired,
  traits: PropTypes.object.isRequired
}

export default CustomersProfileTraits



// WEBPACK FOOTER //
// ./components/Customers/CustomersProfileTraits.js